// PGCET MCA Mock 4 — General Awareness (questions 71–90)
const pgcetmcaGeneralAwareness = [
  {
    id: 71,
    question: "The Comptroller and Auditor General (CAG) of India is appointed by the",
    options: ["A. Prime Minister", "B. President", "C. Parliament", "D. Chief Justice of India"],
    answer: "B"
  },
  {
    id: 72,
    question: "The languages officially recognised by the Constitution of India are listed in its",
    options: ["A. Seventh Schedule", "B. Ninth Schedule", "C. Tenth Schedule", "D. Eighth Schedule"],
    answer: "D"
  },
  {
    id: 73,
    question: "Panchayati Raj institutions were given constitutional status by the",
    options: ["A. 42nd Amendment Act", "B. 44th Amendment Act", "C. 73rd Amendment Act", "D. 86th Amendment Act"],
    answer: "C"
  },
  {
    id: 74,
    question: `Consider the following statements about the Election Commission of India.
      (a) It is a constitutional body set up under Article 324.
      (b) The Chief Election Commissioner is appointed by the President.
      (c) It conducts elections to Panchayats and Municipalities.
      Which of the statements are correct?`,
    options: ["A. (a) and (b) only", "B. (b) and (c) only", "C. (a) and (c) only", "D. (a), (b) and (c)"],
    answer: "A"
  },
  {
    id: 75,
    question: "In the Indian economy, 'disinvestment' refers to",
    options: [
      "A. the government selling part or all of its stake in public sector enterprises",
      "B. the RBI buying government bonds in the open market",
      "C. foreign investors withdrawing money from Indian markets",
      "D. a reduction in income tax rates"
    ],
    answer: "A"
  },
  {
    id: 76,
    question: "A 'bear market' is a market in which",
    options: [
      "A. share prices rise steadily over a long period",
      "B. share prices fall over a sustained period",
      "C. share prices stay unchanged",
      "D. only government bonds are traded"
    ],
    answer: "B"
  },
  {
    id: 77,
    question: "Which body regulates the insurance sector in India?",
    options: ["A. SEBI", "B. PFRDA", "C. IRDAI", "D. NABARD"],
    answer: "C"
  },
  {
    id: 78,
    question: `Match the companies in List-I with their founders in List-II.
      List-I: (a) Infosys (b) Flipkart (c) Zerodha (d) Biocon
      List-II: (i) Kiran Mazumdar-Shaw (ii) Nithin Kamath (iii) N. R. Narayana Murthy (iv) Sachin Bansal and Binny Bansal`,
    options: [
      "A. a-i, b-iv, c-ii, d-iii",
      "B. a-iv, b-iii, c-ii, d-i",
      "C. a-iii, b-ii, c-iv, d-i",
      "D. a-iii, b-iv, c-ii, d-i"
    ],
    answer: "D"
  },
  {
    id: 79,
    question: "The headquarters of the Indian Space Research Organisation (ISRO) is located in",
    options: ["A. Sriharikota", "B. Thiruvananthapuram", "C. Ahmedabad", "D. Bengaluru"],
    answer: "D"
  },
  {
    id: 80,
    question: "The chemical formula of baking soda is",
    options: ["A. Na₂CO₃", "B. NaHCO₃", "C. NaCl", "D. CaCO₃"],
    answer: "B"
  },
  {
    id: 81,
    question: "Which blood group is known as the universal donor?",
    options: ["A. O negative", "B. AB positive", "C. A positive", "D. B negative"],
    answer: "A"
  },
  {
    id: 82,
    question: "Which vitamin is synthesised in the human skin on exposure to sunlight?",
    options: ["A. Vitamin A", "B. Vitamin C", "C. Vitamin K", "D. Vitamin D"],
    answer: "D"
  },
  {
    id: 83,
    question: "Which of the following is a non-renewable source of energy?",
    options: ["A. Solar energy", "B. Wind energy", "C. Coal", "D. Tidal energy"],
    answer: "C"
  },
  {
    id: 84,
    question: "The Western Ghats are also known as the",
    options: ["A. Sahyadri", "B. Aravalli", "C. Satpura", "D. Vindhya"],
    answer: "A"
  },
  {
    id: 85,
    question: "Which Indian state has the longest coastline?",
    options: ["A. Tamil Nadu", "B. Andhra Pradesh", "C. Gujarat", "D. Maharashtra"],
    answer: "C"
  },
  {
    id: 86,
    question: "Jog Falls in Karnataka is formed by the river",
    options: ["A. Kaveri", "B. Sharavati", "C. Tungabhadra", "D. Kali"],
    answer: "B"
  },
  {
    id: 87,
    question: "The first session of the Indian National Congress was held in 1885 at",
    options: ["A. Calcutta", "B. Bombay", "C. Madras", "D. Allahabad"],
    answer: "B"
  },
  {
    id: 88,
    question: "The Vijayanagara Empire was founded in 1336 by",
    options: ["A. Krishnadevaraya", "B. Pulakeshin II", "C. Tipu Sultan", "D. Harihara I and Bukka Raya I"],
    answer: "D"
  },
  {
    id: 89,
    question: "The Government of India launched the 'Digital India' programme in",
    options: ["A. 2013", "B. 2014", "C. 2015", "D. 2016"],
    answer: "C"
  },
  {
    id: 90,
    question: "The Bharat Ratna is India's",
    options: ["A. highest civilian award", "B. highest gallantry award", "C. highest literary award", "D. highest sports award"],
    answer: "A"
  }
];

export default pgcetmcaGeneralAwareness;
